<template>
	<b-modal
		v-model="viewLink"
		id="viewlink"
		centered
		hide-footer
		no-close-on-backdrop
		:title="!editAsset ? 'View Link' : 'Edit Link'"
	>
		<section class="position-absolute viewimage-header-icons mr-2">
			<img
				v-if="!editAsset && $route.name !== 'coursecreation'"
				@click="$emit('changeVal', 'editAsset')"
				src="@/assets/common/edit.svg"
				alt=""
				class="mr-2 pointer"
			/><img
				v-if="!editAsset && $route.name !== 'coursecreation'"
				@click="$emit('changeVal', 'delete', 'viewLink')"
				src="@/assets/common/delete.svg"
				alt=""
				class="mr-2 pr-2 ab-right-line pointer"
			/>
			<img
				@click="$emit('closeModal', 'viewLink')"
				class="rotate-on-hover pointer"
				src="@/assets/common/blue-cross.svg"
				alt=""
			/>
		</section>

		<section class="p-3" v-if="!editAsset">
			<div class="header-container mb-3" style="background: #eef3f7">
				<h1 class="fw-500">{{ showDetails.title }}</h1>
			</div>
			<span
				class="ab-lv-tags"
				v-for="(tag, index) in showDetails.tags"
				:key="index"
			>
				#{{ tag }}</span
			>
			<div class="viewlink-card mt-3 d-flex align-items-center">
				<img src="@/assets/asset-bank/listview/view-link-icon.svg" alt="" />
				<span class="viewlinkcard-heading ml-2 word-break"
					>{{ showDetails.link }} <br />
					<!-- <span class="viewlinkcard-subheading"
							>hire3x.com</span
						> -->
				</span>
			</div>
		</section>

		<section v-else class="px-2 py-3">
			<Links
				:linkData="showDetails"
				:validation="validation"
				:editAsset="editAsset"
			/>
		</section>
		<hr v-if="editAsset" />
		<div
			class="d-flex justify-content-end align-items-center px-3 pb-3"
			v-if="editAsset"
		>
			<OButton
				class="p1-15"
				@clicked="$emit('closeModal', 'viewLink')"
				text="Cancel"
			/>
			<PButton
				:loading="loading"
				widthClass="button-width"
				class="ml-2 p1-15"
				text="Update"
				@clicked="$emit('handle-save')"
			/>
		</div>
	</b-modal>
</template>
<script>
import Links from "./Links.vue";

export default {
	props: {
		viewLink: Boolean,
		showDetails: Object,
		editAsset: Boolean,
		validation: Object,
		loading: Boolean,
	},
	components: {
		Links,
	},
};
</script>
